import * as React from "react";

export const NoAccessNotification = (props: { message: string }) => {
    return <div className="no-access-notification-container" data-testid="no-access-notification-container">
        <div className="no-access-notification">
            <b>{props.message}</b>
        </div>
    </div>;
};
